import React, { useState,useEffect } from "react";
import Header from '../../layout/header';
import Loader from "../../../Loader/Loader";
import DashboardMenu from "../../layout/dashboardMenu";
import axios from 'axios'
import NotFoundData from "../../../Images/no-data-found.webp";
import *  as Constants from '../constants';
import { Modal,  Card, Row, Col ,Button} from 'react-bootstrap';
 
import { toast } from "react-toastify";
import SuccessModal from "../../CustomModal/Success";
import ModalPop from '../../modal/modal';

const LeadsOptions = ({
    allLeads=[],
    getAllLeadsListing,
    updateLeadStatus,
    updatedLead=[]
}) => {
    const [isLoading, setIsLoading] = useState(false);
    const [showApproveModal,setShowApproveModal]=useState(false);
    const [showHoldModal,setShowHoldModal]=useState(false);
    const [showRejectModal,setShowRejectModal]=useState(false);
    const [rejectionReasons,setRejectionReasons]=useState([]);
    const [holdReasons,setHoldReasons]=useState([]);
    const [leadId,setLeadId]=useState(null);
    const [categories,setCategories]=useState([]);
    const [departmentOptions,setDepartmentOptions]=useState([]);
    const [userOptions, setUserOptions] = useState([]);
    const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false);
    const [formData, setFormData] = useState({
            lead_id:'',
            utm_source:'',
            name:'',
            contact_no:'',
            category:'',
            call_date:'',
            call_no:'',
            department_id:'',
            next_call_date:'',
            hold_remarks:'',
            rejection_remarks:'',
            other_remarks:'',
            status:'',
            next_action:''
        });
    const START_DATE='2025-02-24';

    useEffect(() => {
        (async () => {
            // document.body.style.zoom = "70%";
            setIsLoading(true)
            const today = new Date().toISOString().split('T')[0]; 
            const res =await getAllLeadsListing([2,4],[{'next_call_from_date':START_DATE,'next_call_to_date':today}],'',1,false)
            const { lead_data,rejection_reasons,hold_reasons,departments,assignees} = res;
            setDepartmentOptions(departments);
            setUserOptions(assignees)
            setRejectionReasons(rejection_reasons??[])
            setHoldReasons(hold_reasons??[])
            setIsLoading(false)
        })()
    }, []);
    
    useEffect(() => {
        (async () => {
            // setIsLoading(true);
            const leadFound=allLeads?.data?.find(lead=>lead.id==leadId);
            setFormData({
                lead_id:leadFound?.id,
                utm_source:leadFound?.utm_source,
                name:leadFound?.name,
                contact_no:leadFound?.contact_no,
                category:leadFound?.category,
                call_date:new Date().toISOString().split('T')[0] || '',
                call_no:parseInt(leadFound?.total_calls)+1,
                status:leadFound?.status,
                department_id:'',
                next_call_date:'',
                hold_reason:'',
                rejection_reason:'',
                other_remarks:'',
            });
            // setIsLoading(false); 
        })();
    }, [leadId]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        console.log(name,value)
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };
    
    const handleApproval = async () => {
        setIsLoading(true)
        const validateForm = () => {
            if (!formData.department_id) {
                toast.error("Department is required");
                return false;
            }
            if (!formData.account_id) {
                toast.error("Account ID is required");
                return false;
            }
            if (!formData.next_call_date) {
                toast.error("Next Call Date is Required");
                return false;
            }
            if (!formData.assigned_user_id) {
                toast.error("Assigned User is Required");
                return false;
            }
            return true;
        };
        try {
            setIsLoading(true);
            console.log(formData)
            if (!validateForm()) {
                setIsLoading(false);     
                return;
            }
            const response = await updateLeadStatus({ ...formData, next_action: Constants.LEAD_STATUS_VERIFIED });
            
            if (response.status) {
                setShowApproveModal(false)
                setIsSuccessModalOpen(true)
                
            }else{
                const message=response?.response?.message
                if(message){
                    toast.error(response.response.message)
                }else{
                    toast.error("Something went wrong")
                }
            }
            setIsLoading(false);     
        } catch (error) {
            console.error("Error while approving referral:", error);
            setIsLoading(false);     
        }
    };

    const handleRejection = async () => {
        try {
            const validateForm = () => {
                if (!formData.rejection_reason) {
                    toast.error("Rejection Reason is required");
                    return false;
                }
                if (formData?.rejection_reason!='' && 
                    (formData?.rejection_reason== Constants?.REJECTION_CITY_NOT_SERVICEABLE || 
                    formData?.rejection_reason == Constants?.REJECTION_OTHER) && 
                    formData?.other_remarks==''
                ) {
                    toast.error("Remarks is required");
                    return false;
                }
                return true;
            };

            setIsLoading(true);
            if (!validateForm()) {
                setIsLoading(false);     
                return;
            }
            const response = await updateLeadStatus({ ...formData, next_action: Constants.LEAD_STATUS_REJECTED });
            
            if (response.status) {
                setShowRejectModal(false)
                setIsSuccessModalOpen(true)
            }else{
                const message=response?.response?.message
                if(message){
                    toast.error(response.response.message)
                }else{
                    toast.error("Something went wrong")
                }
            }
            setIsLoading(false);         
        } catch (error) {
            console.error("Error while rejecting referral:", error);
            setIsLoading(false);     
        }
    };

    const handleHold = async () => {
        try {
            const validateForm = () => {
                if (!formData?.next_call_date) {
                    toast.error("Next Call Date is Required");
                    return false;
                }
                if (!formData?.hold_reason) {
                    toast.error("Rejection Reason is required");
                    return false;
                }
                console.log(formData?.hold_reason)
                console.log(formData?.other_remarks)
                if (formData?.hold_reason!='' && 
                    (formData?.hold_reason== Constants?.HOLD_CITY_NOT_SERVICEABLE || 
                    formData?.hold_reason == Constants?.HOLD_OTHER) && 
                    formData?.other_remarks==''
                ) {
                    toast.error("Remarks is required");
                    return false;
                }
                return true;
            };

            setIsLoading(true);
            if (!validateForm()) {
                setIsLoading(false);     
                return;
            }
            const response = await updateLeadStatus({ ...formData, next_action: Constants.LEAD_STATUS_HOLD });
            
            if (response.status) {
                setShowHoldModal(false)
                setIsSuccessModalOpen(true)
            }else{
                const message=response?.response?.message
                if(message){
                    toast.error(response.response.message)
                }else{
                    toast.error("Something went wrong")
                }
            }
            setIsLoading(false);         
        } catch (error) {
            console.error("Error while rejecting referral:", error);
            setIsLoading(false);     
        }
    };

    function closeModal() {
        setShowApproveModal(false);
        setShowRejectModal(false);
        setShowHoldModal(false);
        setLeadId(null);
        setFormData({
            lead_id:'',
            utm_source:'',
            name:'',
            contact_no:'',
            category:'',
            call_date: '',
            call_no:'',
            status:'',
            department_id:'',
            meeting_date:'',
            next_call_date:'',
            hold_reason:'',
            rejection_reason:'',
            other_remarks:'',
        });
        // window.location.reload()
    }
    return (
        <>
          <Loader isLoading={isLoading} />
          <SuccessModal
                isOpen={isSuccessModalOpen}
                msg={'Data updated successfully'}
                url={window.location}
            />
          <ModalPop
                title="Fill the following details"
                show={showApproveModal}
                handleModalHide={closeModal}
                keyboard
                backdrop
                className="modal-lg"
            >
                {/* <div className="container"> */}
                    <div className="row g-3"> 
                        {/* First Column */}
                        <div className="col-sm-12 col-md-6">
                            <div className="mb-3">
                                <label htmlFor="lead_id" className="form-label">Lead ID</label>
                                <input type="number" id="lead_id" className="form-control" value={formData.lead_id} readOnly disabled/>
                            </div>
                            <div className="mb-3">
                                <label htmlFor="utm_source" className="form-label">UTM Source</label>
                                <input type="text" id="utm_source" className="form-control" value={formData.utm_source} readOnly disabled/>
                            </div>
                            <div className="mb-3">
                                <label htmlFor="name" className="form-label">Name</label>
                                <input type="text" id="name" className="form-control" value={formData.name} readOnly disabled/>
                            </div>
                            <div className="mb-3">
                                <label htmlFor="contact_no" className="form-label">Contact No.</label>
                                <input type="text" id="contact_no" className="form-control" value={formData.contact_no} readOnly disabled/>
                            </div>
                            <div className="mb-3">
                                
                                <label htmlFor="category" className="form-label">Category</label>
                                <select
                                    className="form-control"
                                    id="category"
                                    name="category"
                                    value={formData.category}
                                    onChange={handleInputChange}
                                    required
                                >
                                    <option value="">Choose...</option>
                                    {categories?.map(category => (
                                        <option key={category.id} value={category.name}>
                                            {category.name}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <div className="mb-3">
                                <label htmlFor="call_date" className="form-label">Call Date</label>
                                <input type="date" id="call_date" className="form-control" value={formData.call_date} readOnly disabled/>
                            </div>
                        </div>

                        {/* Second Column */}
                        <div className="col-sm-12 col-md-6">
                            
                            <div className="mb-3">
                                <label htmlFor="call_no" className="form-label">Call No</label>
                                <input type="number" id="call_no" className="form-control" value={formData.call_no} readOnly disabled/>
                            </div>
                            <div className="mb-3">
                                <label htmlFor="department_id" className="form-label">Department<span className="text-danger">*</span></label>
                                <select
                                    id="department_id"
                                    name="department_id"
                                    className="form-control"
                                    onChange={handleInputChange}
                                    value={formData.department_id || ''}
                                >
                                    <option value="">Choose...</option>
                                    {departmentOptions.map(option => (
                                        <option key={option.id} value={option.id}>
                                            {option.name}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <div className="mb-3">
                                <label htmlFor="account_id" className="form-label">Account ID<span className="text-danger">*</span></label>
                                <input 
                                    type="text" 
                                    id="account_id" 
                                    className="form-control" 
                                    value={formData.account_id} 
                                    onChange={(e) => setFormData({ ...formData, account_id: e.target.value })} 
                                />
                            </div>
                            <div className="mb-3">
                                <label htmlFor="next_call_date" className="form-label">Next Call Date<span className="text-danger">*</span></label>
                                <input 
                                    type="date" 
                                    id="next_call_date" 
                                    className="form-control" 
                                    min={new Date().toISOString().split('T')[0]}
                                    value={formData.next_call_date || ''} 
                                    onChange={(e) => setFormData({ ...formData, next_call_date: e.target.value })} 
                                />
                            </div>
                            <div className="mb-3">
                                <label htmlFor="meeting_date" className="form-label">Meeting Date<span className="text-danger">*</span></label>
                                <input 
                                    type="date" 
                                    id="meeting_date" 
                                    className="form-control" 
                                    min={new Date().toISOString().split('T')[0]}
                                    value={formData.meeting_date || ''} 
                                    onChange={(e) => setFormData({ ...formData, meeting_date: e.target.value })} 
                                />
                            </div>
                            <div className="mb-4">
                                <label htmlFor="assignedUser" className="form-label">Assign User<span className="text-danger">*</span></label>
                                <select
                                    id="assignedUser"
                                    name="assigned_user_id"
                                    className="form-control"
                                    onChange={handleInputChange}
                                    value={formData?.assigned_user_id || ''}
                                >
                                    <option value="">Choose...</option>
                                    {userOptions.map(option => (
                                        <option key={option.id} value={option.id}>
                                            {option.name}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>
                    {/* </div> */}

                    {/* Submit Button */}
                    <div className="w-100 d-flex items-center text-center mt-3" style={
                        {display: "flex",
                        justifyContent: "center"
                        }}>
                        <button 
                            type="button" 
                            onClick={handleApproval}
                            className="btn btn-primary px-4" 
                        >
                            Submit
                        </button>
                    </div>
                </div>
            </ModalPop>

            <ModalPop
                title='Fill the following details'
                show={showRejectModal}
                handleModalHide={closeModal}
                keyboard
                backdrop
            >
                <div className="row g-3"> 
                        {/* First Column */}
                        <div className="col-sm-12 col-md-6">
                            <div className="mb-3">
                                <label htmlFor="lead_id" className="form-label">Lead ID</label>
                                <input type="number" id="lead_id" className="form-control" value={formData.lead_id} readOnly disabled/>
                            </div>
                            <div className="mb-3">
                                <label htmlFor="utm_source" className="form-label">UTM Source</label>
                                <input type="text" id="utm_source" className="form-control" value={formData.utm_source} readOnly disabled/>
                            </div>
                            <div className="mb-3">
                                <label htmlFor="name" className="form-label">Name</label>
                                <input type="text" id="name" className="form-control" value={formData.name} readOnly disabled/>
                            </div>
                            <div className="mb-3">
                                <label htmlFor="contact_no" className="form-label">Contact No.</label>
                                <input type="text" id="contact_no" className="form-control" value={formData.contact_no} readOnly disabled/>
                            </div>
                            <div className="mb-3">
                                
                                <label htmlFor="category" className="form-label">Category</label>
                                <select
                                    className="form-control"
                                    id="category"
                                    name="category"
                                    value={formData.category}
                                    onChange={handleInputChange}
                                    required
                                    disabled={true}
                                >
                                    <option value="">Choose...</option>
                                    {categories?.map(category => (
                                        <option key={category.id} value={category.name}>
                                            {category.name}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>

                        {/* Second Column */}
                        <div className="col-sm-12 col-md-6">
                            <div className="mb-3">
                                <label htmlFor="call_date" className="form-label">Call Date</label>
                                <input type="date" id="call_date" className="form-control" value={formData.call_date} readOnly disabled/>
                            </div>
                            <div className="mb-3">
                                <label htmlFor="call_no" className="form-label">Call No</label>
                                <input type="number" id="call_no" className="form-control" value={formData.call_no} readOnly disabled/>
                            </div>
                            <div className="mb-4">
                                <label htmlFor="rejectionReasons" className="form-label">Rejection Reason<span className="text-danger">*</span></label>
                                <select
                                    id="rejectionReasons"
                                    name="rejection_reason"
                                    className="form-control"
                                    onChange={handleInputChange}
                                    value={formData?.rejection_reason || ''}
                                >
                                    <option value="">Choose...</option>
                                    {rejectionReasons.map(option => (
                                        <option key={option.id} value={option.id}>
                                            {option.name}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            
                            {(formData.rejection_reason== Constants?.REJECTION_CITY_NOT_SERVICEABLE || formData.rejection_reason== Constants?.REJECTION_OTHER )&&
                                <div className="mb-4">
                                    <label htmlFor="other_remarks" className="form-label">Remarks<span className="text-danger">*</span></label>
                                    <textarea
                                        id="other_remarks"
                                        name="other_remarks"
                                        className="form-control"
                                        rows="3"
                                        onChange={handleInputChange}
                                    />
                                </div>
                            }
                        </div>
                    {/* </div> */}

                    {/* Submit Button */}
                    <div className="w-100 d-flex items-center text-center mt-3" style={
                        {display: "flex",
                        justifyContent: "center"
                        }}> 
                        <button 
                            type="button" 
                            onClick={handleRejection}
                            className="btn btn-primary px-4" 
                        >
                            Submit
                        </button>
                    </div>
                </div>
            </ModalPop>
            <ModalPop
                title='Fill the following details'
                show={showHoldModal}
                handleModalHide={closeModal}
                keyboard
                backdrop
                // url={url}
            >
                <div className="row g-3"> 
                        {/* First Column */}
                        <div className="col-sm-12 col-md-6">
                            <div className="mb-3">
                                <label htmlFor="lead_id" className="form-label">Lead ID</label>
                                <input type="number" id="lead_id" className="form-control" value={formData.lead_id} readOnly disabled/>
                            </div>
                            <div className="mb-3">
                                <label htmlFor="utm_source" className="form-label">UTM Source</label>
                                <input type="text" id="utm_source" className="form-control" value={formData.utm_source} readOnly disabled/>
                            </div>
                            <div className="mb-3">
                                <label htmlFor="name" className="form-label">Name</label>
                                <input type="text" id="name" className="form-control" value={formData.name} readOnly disabled/>
                            </div>
                            <div className="mb-3">
                                <label htmlFor="contact_no" className="form-label">Contact No.</label>
                                <input type="text" id="contact_no" className="form-control" value={formData.contact_no} readOnly disabled/>
                            </div>
                            <div className="mb-3">
                                
                                <label htmlFor="category" className="form-label">Category</label>
                                <select
                                    className="form-control"
                                    id="category"
                                    name="category"
                                    value={formData.category}
                                    onChange={handleInputChange}
                                    required
                                    disabled={true}
                                >
                                    <option value="">Choose...</option>
                                    {categories?.map(category => (
                                        <option key={category.id} value={category.name}>
                                            {category.name}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>

                        {/* Second Column */}
                        <div className="col-sm-12 col-md-6">
                            <div className="mb-3">
                                <label htmlFor="call_date" className="form-label">Call Date</label>
                                <input type="date" id="call_date" className="form-control" value={formData.call_date} readOnly disabled/>
                            </div>
                            <div className="mb-3">
                                <label htmlFor="call_no" className="form-label">Call No</label>
                                <input type="number" id="call_no" className="form-control" value={formData.call_no} readOnly disabled/>
                            </div>
                            <div className="mb-3">
                                <label htmlFor="next_call_date" className="form-label">Next Call Date<span className="text-danger">*</span></label>
                                <input 
                                    type="date" 
                                    id="next_call_date" 
                                    className="form-control" 
                                    value={formData.next_call_date || ''} 
                                    min={new Date().toISOString().split('T')[0]}
                                    onChange={(e) => setFormData({ ...formData, next_call_date: e.target.value })} 
                                />
                            </div>
                            
                            <div className="mb-4">
                                <label htmlFor="holdReasons" className="form-label">Hold Reason<span className="text-danger">*</span></label>
                                <select
                                    id="holdReasons"
                                    name="hold_reason"
                                    className="form-control"
                                    onChange={handleInputChange}
                                    value={formData?.hold_reason || ''}
                                >
                                    <option value="">Choose...</option>
                                    {holdReasons.map(option => (
                                        <option key={option.id} value={option.id}>
                                            {option.name}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            {(formData.hold_reason== Constants?.HOLD_CITY_NOT_SERVICEABLE || formData.hold_reason== Constants?.HOLD_OTHER )&&
                                <div className="mb-4">
                                    <label htmlFor="other_remarks" className="form-label">Remarks<span className="text-danger">*</span></label>
                                    <textarea
                                        id="other_remarks"
                                        name="other_remarks"
                                        className="form-control"
                                        rows="3"
                                        onChange={handleInputChange}
                                    />
                                </div>
                            }
                        </div>
                    {/* </div> */}

                    {/* Submit Button */}
                    <div className="col-md-12 d-flex items-center text-center mt-3" style={
                        {display: "flex",
                        justifyContent: "center"
                        }}>
                        <button 
                            type="button" 
                            onClick={handleHold}
                            className="btn btn-primary px-4" 
                        >
                            Submit
                        </button>
                    </div>
                </div>
            </ModalPop>
          <div id="wrapper">
            <DashboardMenu />
            <div id="content-wrapper" className="d-flex flex-column">
              <div id="content">
                <Header title={'Leads Management System'} />
                <div className="container-fluid common-bg">
                    <div className="container-fluid bootstrap snippets bg-white">
                        <div className="row">
                            <div className="col-md-12 d-flex flex-column mt-20px">
                                <h1 className="h3 mb-4 text-black-100">Leads Management System</h1>
                                <div className="row">
                                    <div className="col-md-3 mb-3">
                                        <a href="/pending-leads" style={{ textDecoration: 'none' }}>
                                            <div className="card bg-primary text-white border-0" style={{ width: '100%', height: '60px' }}>
                                                <div className="card-body d-flex flex-column align-items-center justify-content-center text-center p-2">
                                                    <h5 className="card-title" style={{ fontSize: '1.25rem', margin: 0 }}>Pending Action</h5>
                                                </div>
                                            </div>
                                        </a>
                                    </div>
                                    <div className="col-md-3 mb-3">
                                        <a href="/hold-leads" style={{ textDecoration: 'none' }}>
                                            <div className="card bg-primary text-white border-0" style={{ width: '100%', height: '60px' }}>
                                                <div className="card-body d-flex flex-column align-items-center justify-content-center text-center p-2">
                                                    <h5 className="card-title" style={{ fontSize: '1.25rem', margin: 0 }}>On Hold</h5>
                                                </div>
                                            </div>
                                        </a>
                                    </div>
                                    <div className="col-md-3 mb-3">
                                        <a href="/verified-leads" style={{ textDecoration: 'none' }}>
                                            <div className="card bg-primary text-white border-0" style={{ width: '100%', height: '60px' }}>
                                                <div className="card-body d-flex flex-column align-items-center justify-content-center text-center p-2">
                                                    <h5 className="card-title" style={{ fontSize: '1.25rem', margin: 0 }}>Verified</h5>
                                                </div>
                                            </div>
                                        </a>
                                    </div>
                                    <div className="col-md-3 mb-3">
                                        <a href="/rejected-leads" style={{ textDecoration: 'none' }}>
                                            <div className="card bg-primary text-white border-0" style={{ width: '100%', height: '60px' }}>
                                                <div className="card-body d-flex flex-column align-items-center justify-content-center text-center p-2">
                                                    <h5 className="card-title" style={{ fontSize: '1.25rem', margin: 0 }}>Rejected</h5>
                                                </div>
                                            </div>
                                        </a>
                                    </div>
                                </div>

                            </div>
                            <div className="col-md-12 d-flex flex-column m-3">
                                <h3>Calls scheduled for today :- </h3>
                            </div>
                            <div className="row">
                            {allLeads?.data?.length > 0 ? (
                                allLeads.data.map((lead, index) => (
                                    <div className="col-md-4 col-sm-6" key={index}>
                                    <div className="card-big-shadow card-padding">
                                    <div className="card card-just-text" data-background="color" data-color="" data-radius="none">
                                        <div className="content">
                                        <h6 className="category">
                                            <div className={`header-ui-item-opp bg-${lead?.status_colour_class}`}>
                                            {lead?.status_text || 'N/A'}
                                            </div>

                                            <div className="row">
                                            <div className="col-10" style={{ color: "#000", fontSize: "20px", textAlign: "left", paddingLeft: "20px" }}>
                                                <span className="">{lead?.society_name || 'N/A'}</span>
                                            </div>
                                            </div>

                                            <div className="row list-view">
                                                <div className="mb-flex">
                                                    <div className="col-md-6 col-sm-6 no-wrap">
                                                        <i className="fas fa-city" style={{ color: "brown" }}></i>&nbsp;&nbsp;City
                                                    </div>
                                                    <div className="col-md-6 col-sm-6">{lead?.city || 'N/A'}</div>
                                                </div>
                                                <div className="mb-flex">
                                                    <div className="col-md-6 col-sm-6 no-wrap">
                                                        <i className="far fa-calendar-alt" style={{ color: "steelblue" }}></i>&nbsp;&nbsp;Scheduled Date
                                                    </div>
                                                    <div className="col-md-6 col-sm-6">
                                                        {lead?.next_call_date ? new Date(lead.next_call_date).toISOString().split('T')[0] : 'N/A'}
                                                    </div>
                                                </div>
                                                <div className="mb-flex">
                                                    <div className="col-md-6 col-sm-6 no-wrap">
                                                        <i className="fas fa-user" style={{ color: "green" }}></i>&nbsp;&nbsp;Name
                                                    </div>
                                                    <div className="col-md-6 col-sm-6">{lead?.name || 'N/A'}</div>
                                                </div>
                                                <div className="mb-flex">
                                                    <div className="col-md-6 col-sm-6 no-wrap">
                                                        <i className="fas fa-phone-alt" style={{ color: "blue" }}></i>&nbsp;&nbsp;Contact No.
                                                    </div>
                                                    <div className="col-md-6 col-sm-6">{lead?.contact_no || 'N/A'}</div>
                                                </div>
                                                <div className="mb-flex">
                                                    <div className="col-md-6 col-sm-6 no-wrap">
                                                        <i className="fas fa-envelope" style={{ color: "red" }}></i>&nbsp;&nbsp;Email ID
                                                    </div>
                                                    <div className="col-md-6 col-sm-6">{lead?.email_id || 'N/A'}</div>
                                                </div>
                                                <div className="mb-flex">
                                                    <div className="col-md-6 col-sm-6 no-wrap">
                                                        <i className="fas fa-bullhorn" style={{ color: "purple" }}></i>&nbsp;&nbsp;UTM Source
                                                    </div>
                                                    <div className="col-md-6 col-sm-6">{lead?.utm_source || 'N/A'}</div>
                                                </div>
                                            </div>

                                            <hr />
                                            {
                                                lead?.status==2 && (
                                                    <button className="btn btn-primary btn-sm mx-4" style={{ width: '80px'}}
                                                        onClick={()=>{
                                                            setLeadId(lead.id)
                                                            setShowHoldModal(true)
                                                        }}
                                                        >
                                                            Log Call
                                                    </button>
                                                )
                                            }
                                            {
                                                lead?.status==4 && (
                                                <div className="list-inline d-flex align-items-center">
                                                    <button className="btn btn-success btn-sm mx-4" style={{ width: '80px'}}
                                                        onClick={()=>{
                                                            setLeadId(lead.id)
                                                            setShowApproveModal(true)
                                                        }}
                                                    >
                                                        Approve
                                                    </button>
                                                
                                                    <button className="btn btn-danger btn-sm mx-4" style={{ width: '80px'}}
                                                            onClick={()=>{
                                                                setLeadId(lead.id)
                                                                setShowRejectModal(true)
                                                            }}
                                                            >
                                                        Reject
                                                    </button>
                                                    
                                                    <button className="btn btn-info btn-sm mx-4" style={{ width: '80px'}}
                                                            onClick={()=>{
                                                                setLeadId(lead.id)
                                                                setShowHoldModal(true)
                                                            }}
                                                            >
                                                        Hold
                                                    </button>
                                                    
                                                </div>
                                                )
                                            }
                                            
                                        </h6>
                                        </div>
                                    </div>
                                    </div>
                                </div>
                                ))
                            ) : (
                                <>
                                    <img src={NotFoundData} className="not-found-data" alt={""}/>
                                    <div className="text-center" style={{"width": "100%"}}>
                                        No Meetings scheduled for today
                                    </div>
                                </>
                            )}
                            </div>
                        </div>
                    </div>
                </div>
              </div>
            </div>
          </div>
        </>
      );
};

export default LeadsOptions;